import { helpers } from 'veritone-redux-common';

const { createReducer } = helpers;

export const GET_APP_SETTING = "get app setting"
export const GET_APP_SETTING_SAGA = "get app setting saga"
export const UPDATE_APP_SETTING = "update app setting"
export const UPDATE_APP_SETTING_SAGA = "update app setting saga"
export const LOAD_ORG_LOGO_SAGA = "load org logo saga"

const appSettingReducer = createReducer({}, {
    [GET_APP_SETTING]: (state, action) => {
        const { data } = action.payload
        return {
            ...state,
            data
        }
    },
    [UPDATE_APP_SETTING]: (state, action) => {
        const { data } = action.payload;
        const listSettingName = data.map(item => item.setting_name);
        const oldData = state.data.filter(setting => 
            !listSettingName.includes(setting.setting_name)
        )
        return {
            ...state,
            data: [
                ...data,
                ...oldData
            ]
        }
    }
})

export const loadOrgLogoSaga = () => ({
    type: LOAD_ORG_LOGO_SAGA,
    payload: {}
})

export const updateAppSetting = (data) => ({
    type: UPDATE_APP_SETTING,
    payload: {
        data
    }
})

export const getAppSetting = (data) => ({
    type: GET_APP_SETTING,
    payload: {
        data
    }
})

export const namespace = "appSetting"

export const getAppSettingSaga = () => ({
    type: GET_APP_SETTING_SAGA
})

export const updateAppSettingSaga = (appSetting) => ({
    type: UPDATE_APP_SETTING_SAGA,
    payload: {
        appSetting
    }
})

export default appSettingReducer